import { render, staticRenderFns } from "./TestoPrivacy.vue?vue&type=template&id=1e2ed3b2&scoped=true"
var script = {}
import style0 from "./TestoPrivacy.vue?vue&type=style&index=0&id=1e2ed3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2ed3b2",
  null
  
)

export default component.exports